/** Optional Part 7 - EDI identity survey (workplace + educator modules). */

export const WORKPLACE_EDI_IDENTITY_TITLE = 'Equity, Diversity, and Inclusion';

export const WORKPLACE_EDI_IDENTITY_INTRO_BODY =
  'Equity, diversity, and inclusion are central to this project. We are collecting this data about the identities of learners to help us better understand and serve you. If you are willing to share elements of your identity with us, please complete this optional survey. Your individual response will be kept in confidence and will not be made public. Deidentified group data may be shared with various stakeholders and/or publicly in reports and other written or electronic communication. If the list is missing an identity factor that you believe should be added or expanded, please add it to Another. This list will be updated in the future as best practices evolve.';

export const WORKPLACE_EDI_IDENTITY_OPTIONS = [
  { value: 'woman', label: 'Woman' },
  { value: 'man', label: 'Man' },
  { value: 'genderNonConforming', label: 'Gender non-conforming' },
  { value: 'southAsian', label: 'South Asian person' },
  { value: 'black', label: 'Black person' },
  { value: 'indigenous', label: 'Indigenous person' },
  { value: 'racialized', label: 'Racialized person' },
  { value: 'white', label: 'White person' },
  { value: 'immigrantUnder5', label: 'Immigrant to Canada 5 years or less' },
  { value: 'immigrantOver5', label: 'Immigrant to Canada over 5 years' },
  { value: 'refugeeUnder5', label: 'Refugee to Canada 5 years or less' },
  { value: 'refugeeOver5', label: 'Refugee to Canada over 5 years' },
  { value: 'visibleDisability', label: 'Person with a visible disability' },
  { value: 'invisibleDisability', label: 'Person with an invisible disability' },
  { value: 'neurodivergent', label: 'Neurodivergent' },
  { value: 'preferNotToAnswer', label: 'Prefer not to answer' },
  { value: 'another', label: 'Another (please specify)' },
];

/** Stable order for export encoding (0-based indices). */
export const WORKPLACE_EDI_IDENTITY_VALUE_ORDER = WORKPLACE_EDI_IDENTITY_OPTIONS.map((o) => o.value);
